import { Box, styled } from '@mui/material';

export const StyledModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  elevation: 3,
  padding: theme.spacing(1),
  fontFamily: theme.typography.subtitle1.fontFamily,
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.subtitle1.fontWeight,
}));
